/* eslint-disable react/prop-types */
import { monnifyLogo } from "@/assets";

import { useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const Monnify = ({ loading }) => {
  const [amount, setAmount] = useState(null);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);

  const getMonnifyDetails = (e) => {
    e.preventDefault();
    window.MonnifySDK.initialize({
      amount: amount,
      currency: "NGN",
      reference: new Date().getTime().toString(),
      customerFullName: user.name,
      customerEmail: user.email,
      apiKey: user.meta_data.monnify_api_key,
      contractCode: user.meta_data.monnify_contract,
      paymentDescription: "Monnify Funding",
      isTestMode: false,
      onComplete: (response) => {
        // console.log("Transaction completed:", response);
        if (response.status === "SUCCESS") {
          navigate("/payment-successful");
          // toast.success("Payment successful!");
        }
        setAmount(null);
      },
      onClose: (data) => {
        // console.log("Monnify modal closed:", data);
        toast.info("Payment window closed");
        setAmount(null);
      },
    });
  };

  return (
    <div className="dark:bg-darkInput rounded-[20px] bg-white p-4 shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src={monnifyLogo}
            alt="monnify-logo"
            className="size-10 rounded-full"
          />
          <h2 className="text-lg font-bold">Monnify</h2>
        </div>
      </div>
      <div className="py-3 text-sm opacity-80">
        Fund your wallet instantly using card, bank transfer, or USSD payment
        methods.
      </div>

      <form onSubmit={getMonnifyDetails} className="flex flex-col gap-2">
        <div className="dark:border-darkBorder dark:bg-darkInput flex items-center gap-x-3 rounded-xl border bg-gray-50 p-2 py-2.5">
          <CurrencyInput
            name="amount"
            placeholder="Input amount (₦)"
            value={amount}
            onValueChange={(value) => setAmount(value)}
            className="w-full border-none bg-transparent text-sm outline-none dark:text-white"
            required
            prefix="₦ "
          />
        </div>
        {/* 
        {error && (
          <span className="py-2  text-sm font-medium text-red-500 md:text-xs">
            {error}
          </span>
        )} */}

        <button
          type="submit"
          className={`bg-primary focus:bg-primary w-full rounded-xl py-3 font-semibold text-white ${
            loading && "opacity-65"
          }`}
          disabled={loading}
        >
          {loading ? "Processing..." : "Proceed"}
          {/* Temporarily Unavailable */}
        </button>
      </form>
    </div>
  );
};

export default Monnify;
